<template>
    <div class="bg-color">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 offset-lg-3 col-sm-8 offset-sm-2 col-xs-10 offset-xs-1 text-center error_content">
                    <div>
                        <div class="error"><span>404</span></div>
                        <div class="error-type"><span>{{ uLang('app.page_not_found') }}</span></div>
                        <div>
                            <p class="error-msg">{{ uLang('app.404_sub_text') }}</p>
                        </div>
                    </div>
                    <hr class="seperator">
                    <router-link to="/" class="btn btn-brand link-home" exact>{{ uLang('app.login') }}</router-link>
                    <a href="/" class="btn btn-brand link-home" @click.prevent.stop="go_back">{{ uLang('app.back') }}</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "err404",
    mounted: function() {

    },
    destroyed: function() {

    },
    methods: {
        go_back() {
            this.$router.go(-1)
        }
    }
}
</script>
<style scoped>
.bg-color {
    background-color: #EEE;
}

.container {
    min-height: 100vh;
    color: #FFF;
}

.error_content {
    margin-top: 7%;
}

.error {
    font-size: 150px;
    line-height: 160px;
    color: #555;
}

.error-type {
    font-size: 28px;
    color: #999;
}

.error-msg {
    font-size: 18px;
    margin: 45px 0;
    color: #333;
}

.seperator {
    border: 0;
    height: 2px;
    margin: 20px 0;
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, .6), rgba(0, 0, 0, 0));
}
</style>
